<template>
  <div id="app">
    <v-app>
      <v-main>
        <SiteNav v-if="showNav"></SiteNav>
        <router-view/>
      </v-main>
    </v-app>    
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SiteNav from '@/components/SiteNav'

export default {
  components: {
    SiteNav
  },
  computed: {
    ...mapState(['userProfile']),
    showNav() {
      //console.log('this.userProfile', this.userProfile)
      return Object.keys(this.userProfile).length > 0
    }
  }
}
</script>

<style>
.v-data-table-header th.sortable{
  padding-top: 12px!important;
}
.v-data-table table tbody tr td{
  padding-top: 14px!important;
  color: #6c757d!important;
  cursor: pointer;
  font-size: 0.85rem!important;
}
.row-v-data-table{
  padding-bottom: 2rem!important;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  padding-top: 8px!important;
}
.v-main__wrap{
  background-color: #fafafa;
}
</style>